module.exports = {
  AUTH_TOKEN_KEY: 'auth_tkn',
  GOOGLE_MAP_KEY: '',
  GOOGLE_MAP_ID: '',
  DATE_FORMAT_API: 'yyyy-MM-DD'
};
